import { ACCESS_LEVEL_ACCESS } from "./accessLevelAccess";
export default {
    [ACCESS_LEVEL_ACCESS.CREATOR]: "Создатель",
    [ACCESS_LEVEL_ACCESS.ADMIN]: "Админ",
    [ACCESS_LEVEL_ACCESS.EDIT]: "Редактор",
    [ACCESS_LEVEL_ACCESS.VIEW]: "Просмотр"
};
